export const httpPoint = {
    user: '/users/',
    proxy: '/proxy/',
    order: '/order/',
    balance: '/balance/',
    paymentMethod: '/payment/'
}

export const boxStyles = {
    backgroundColor: 'background.paper',
    borderRadius: '8px',
    padding: '16px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
}






 
